(ns common.schema.entities.metabase-dashboard
  (:require
   [common.schema.option-filters :as option-filters]
   [common.schema.schema-utils :as su]))

(defn is-dashboard-owner?
  [account dashboard]
  (let [dashboard-owner (:common/owner dashboard)
        dashboard-owner-id (or (:db/id dashboard-owner)
                               dashboard-owner)
        account-id (or (:db/id account) account)]
    (= account-id dashboard-owner-id)))

(defn has-read-access?
  [account account-current-permissions dashboard]
  (let [account-id (or (:db/id account) account)
        account-teams (-> account-current-permissions
                          :account-team-memberships)
        member-ids (->> dashboard
                        :metabase-dashboard/members
                        (map :db/id))
        team-ids (->> dashboard :metabase-dashboard/teams (map :db/id))]
    (or (is-dashboard-owner? account dashboard)
        (some #{account-id} member-ids)
        (some (set team-ids) account-teams))))

(def schema
  (vec
   (concat
    (su/text-simple-field :metabase-dashboard/label
                          "Label"
                          {:default-field-visibility :in-use})
    (su/integer-field :metabase-dashboard/metabase-dashboard-id
                      "Metabase dashboard id"
                      {:default-field-visibility :in-use
                       :editor                   :editor.type/none
                       :authorization            su/access-zadmin-zadmin})
    (su/boolean-field :metabase-dashboard/pipeline-filtering?
                      "Pipeline filtering"
                      {:default-field-visibility :in-use
                       :editor-type                   :editor.type/none
                       :authorization            su/access-zadmin-user})
    (su/text-simple-field :metabase-dashboard/url
                          "URL"
                          {:default-field-visibility :in-use
                           :authorization            su/access-zadmin-zadmin})
    (su/multi-ref-field :metabase-dashboard/members
                        "Authorized members"
                        [:entity.type/account :entity.type/team]
                        {:default-field-visibility :in-use
                         :option-filter-fn         option-filters/active-users
                         :os-filter-terms-fn       (fn [{:keys [] :as args}]
                                                     {"extras.active-user" true})
                         :authorization            su/access-user-user})
    (su/multi-ref-field :metabase-dashboard/teams
                        "Authorized teams"
                        [:entity.type/team]
                        {:default-field-visibility :in-use
                         :authorization            su/access-user-user})
    )))
